import { Typography } from "antd";
import { formatNumber } from "../../utils/functions/formatNumber";
import getRadius from "../../utils/functions/getRadius";
import "../../style/LegendComponent.css";

const { Text } = Typography;

export default function Legend({
  maxValue,
  minValue,
  zoom,
  isXeno,
  isVolume,
  language,
}) {
  const maxRadius = getRadius(maxValue, minValue, maxValue, zoom, true);
  const middleRadius = getRadius(
    maxValue,
    minValue,
    (maxValue - minValue) / 2 + minValue,
    zoom,
    true
  );
  const minRadius = getRadius(maxValue, minValue, minValue, zoom, true);

  function LegendCircle({ radius, maxRadius }) {
    const dimensionMax = maxRadius * 2 + 20;
    return (
      <svg className="legend-circle" height={dimensionMax} width={dimensionMax}>
        <circle
          cx={dimensionMax / 2}
          cy={dimensionMax / 2}
          r={radius}
          stroke={isXeno ? "#308144" : "#177CC5"}
          strokeOpacity="1"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={isXeno ? "#308144" : "#177CC5"}
          fillOpacity="0.2"
          fillRule="evenodd"
        />
      </svg>
    );
  }

  function getFormattedNumber(value, isVolume) {
    let formattedNumber = isVolume
      ? value
      : value.toFixed(1).replace(/[.,]00$/, "");
    return formatNumber(formattedNumber, language);
  }

  return (
    <div className="leaflet-top leaflet-left ">
      <div className="leaflet-control leaflet-bar no-border">
        <div className="legend-container">
          <div className="legend-item">
            <LegendCircle radius={maxRadius} maxRadius={maxRadius} />
            <div className="legend-text">
              <Text>{getFormattedNumber(maxValue, isVolume)}</Text>
            </div>
          </div>
          <div className="legend-item">
            <LegendCircle radius={middleRadius} maxRadius={maxRadius} />
            <div className="legend-text">
              <Text>
                {getFormattedNumber(
                  (maxValue - minValue) / 2 + minValue,
                  isVolume
                )}
              </Text>
            </div>
          </div>
          <div className="legend-item">
            <LegendCircle radius={minRadius} maxRadius={maxRadius} />
            <div className="legend-text">
              <Text>{getFormattedNumber(minValue, isVolume)}</Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
